/**
* 描述：评价系统 --- 评价规则 接口管理
* 录入人： 王帅
*/
import request from '../request.js'

/**
* 描述：添加或修改 评价双方
* 接口管理员：李开明
* 参数： 
{
    judgeRole: '1008002',       //----评价人角色(码表)
    beJudgeRole: '1008001',     //----被评价人角色(码表)
    markObj: '1007001',         //----评价对象(码表)
    applyBus: '1009001'         //----适用业务（码表）
}
*/
export const saveRolesData = function (data) {
    return request({
        url: 'markRule/saveOrUpdateEvaluateBoth',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}

/**
* 描述：评价双方列表数据查询
* 接口管理员：李开明
* 参数：{}
*/
export const getRolesData = function (data) {
    return request({
        url: 'markRule/selectMarkRule',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}

/**
* 描述：删除评价双方
* 接口管理员：李开明
* 参数： 
{
    id: 'xx'    // 当前行id
}
*/
export const deleteRolesData = function (data) {
    return request({
        url: 'markRule/deleteEvaluateBoth',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}

/**
* 描述：右侧规则版本 分页查询
* 接口管理员：李开明
* 参数： 
{
    ruleId: 'xxx',   // 左侧规则表ID
    current: 1,     // 当前分页
    size: 10,       // 每页显示条数
}
*/
export const getRulesData = function (data) {
    return request({
        url: 'markRule/selectRuleVersionPage',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}

/**
* 描述：右侧规则版本 新增、编辑时  选择评分项
* 接口管理员：李开明
* 参数： 
{
    ruleId: 'xxx'   // 左侧规则表ID
}
*/
export const getItemsData = function (data) {
    return request({
        url: 'markRule/selectScoreList',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}

/**
* 描述：右侧规则版本 保存、编辑
* 接口管理员：李开明
* 参数： 
{
    ruleId: 'xxx',          // 左侧规则表ID
    createUserid: '',       // 创建人id
    createUser: '',         // 创建人名称
    sname: '',              // 规则名称
    code: '',               // 规则编号
    version: '',            // 版本号
    remark: '',             // 备注
    totalScore: '',         // 合计单项总分
    markResult: [           // 计分结果
        {type: 0, min: 0, max: 60}
    ],
    details: [],            // 详细评分项数据
}
*/
export const saveRulesData = function (data) {
    return request({
        url: 'markRule/saveOrUpdateEvaluateVersion',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}

/**
* 描述：右侧规则版本 删除
* 接口管理员：李开明
* 参数： 
{
    id: 'xxx'   // 当前行数据ID
}
*/
export const deleteRule = function (data) {
    return request({
        url: 'markRule/deleteRuleVersion',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}

/**
* 描述：右侧规则版本 启用、禁用
* 接口管理员：李开明
* 参数： 
{
    id: 'xxx',      // 当前行数据ID
    status: 0       // 1 启用  0 禁用
}
*/
export const changeRuleState = function (data) {
    return request({
        url: 'markRule/modifyRuleVersionStatus',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}